import styled from 'styled-components'
import cross from '../../assets/addStockModal/pages/cross.svg'
import check from '../../assets/addStockModal/pages/check.svg'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  z-index: 1;
  margin: auto;
  max-width: 90vw;
  max-height: 90vh;
  width: 50rem;
  border-radius: 1vw;
  padding: 1.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  @media (max-height: 720px) {
    max-height: 95vh;
    padding: 1rem;
  }
  
  @media (max-width: 768px) {
    width: 95vw;
    max-width: 95vw;
    padding: 1rem;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 1rem;
  
  h2 {
    margin: 0;
    font-size: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 1.3rem;
    }
    
    @media (max-height: 720px) {
      font-size: 1.2rem;
    }
  }
`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  &:hover{
    background-color: #F4F4F4;
  }
`

export const FormData = styled.div`
  margin-top: 1.4rem;
  display: flex;
  height: 30rem;
  flex-direction: column;
  gap: 2rem;
  overflow: auto
`

export const FormDataDiv = styled.div`
  margin-top: 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  max-height: calc(90vh - 200px);
  
  @media (max-height: 720px) {
    max-height: calc(95vh - 180px);
    gap: 1.5rem;
  }
  
  @media (max-width: 768px) {
    gap: 1rem;
  }
  
  /* Customização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`
export const LineContainer = styled.div`
  display: flex;
  width: 100%;
  /* background-color: red; */
  grid-template-areas: 'Name Email Phone save'
`
export const SectionDiv = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  flex-wrap: wrap;

  &.typesAndFunctions{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &.address{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
    
    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: .3rem;
  width: 100%;
`

export const InputData = styled.input`
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const SelectData = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const Select = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const Option = styled.option`
  background-color: #fff;
  color: #333;
  padding: 0.5rem;
  &:hover {
    background-color: #f0f0f0;
  }
`

export const Label = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.78rem, calc(0.78rem + 0.1vw) , 1.6rem);
`

export const Input = styled.input`
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const InputLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.78rem, calc(0.78rem + 0.1vw) , 1.6rem);
`

export const BottomDiv = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 1.5rem;
  flex-shrink: 0;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
  
  span {
    color: red;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 2rem;
  gap: 1rem;
`

export const ButtonDiv = styled.div`
  background-color: #0090D3;
  color: #fff;
  padding: 1rem 1.6rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  border-radius: 1.5rem;
  user-select: none;
  cursor: pointer;
  white-space: nowrap;
  
  img {
    width: 1rem;
  }
  
  &.cancel {
    border: 1px solid #0090D3;
    color: #0090D3;
    background-color: #fff;
  }

  &.delete {
    border: 1px solid #dc3545;
    color: #dc3545;
    background-color: #fff;
  }
  
  @media (max-width: 768px) {
    padding: 0.8rem 1.2rem;
    font-size: 0.9rem;
  }
`
export const TabsDiv = styled.div`
  display: flex;
  gap: 1rem;
  max-width: 22rem;
  overflow: auto;
`

export const TabDiv = styled.div`
  border: 1px solid #919191;
  padding: .3rem .8rem;
  background-color: #fff;
  border-radius: .8rem;
  display: flex;
  align-items: center;
  gap: .4rem;
  user-select: none;
  img{
    width: .7rem;
    opacity: .7;
    cursor: pointer;
  }
`

export const TabText = styled.span`
  font-size: .8rem;
`

export const CompanyTypesDiv = styled.div`
  display: flex;
  gap: .8rem;
  height: 2.4rem;
`

export const CompanyTypes = styled.div`
  border: 2px solid #B1B1B1;
  border-radius: .9rem;
  padding: .4rem .8rem;
  color: #B1B1B1;
  user-select: none;
  cursor: pointer;

  &.actived{
    color: #0090D3;
    border-color: #0090D3;
    font-weight: 600;
    background-color: #E6F4FB;
  }
`

export const ButtonForCreateAFunction = styled.div`
  font-weight: 700;
  font-size: .9rem;
  cursor: pointer;
  color: #0090D3;
  user-select: none;
  margin-top: .4rem;
`

export const ContactCard = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 1rem;
  margin: 0.5rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: #0091d4;
  }

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    padding: 0.8rem;
    margin: 0.3rem 0;
  }
  
  @media (max-height: 720px) {
    padding: 0.8rem;
    margin: 0.3rem 0;
  }
`

export const ContactHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #e9ecef;
`

export const ContactName = styled.h4`
  margin: 0;
  color: #0091d4;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
`

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ContactField = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ContactLabel = styled.span`
  font-weight: 600;
  color: #495057;
  min-width: 80px;
  font-size: 0.9rem;
`

export const ContactValue = styled.span`
  color: #212529;
  font-size: 0.9rem;
`

export const ContactIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
`

export const ContactsContainer = styled.div`
  margin-top: 1rem;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 0.5rem;
  
  @media (max-height: 720px) {
    max-height: 150px;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`

export const EmptyContactsMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-style: italic;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 2px dashed #dee2e6;
  transition: all 0.3s ease;
  /* animation: pulse 2s infinite; */

  @keyframes pulse {
    0% {
      border-color: #dee2e6;
      transform: scale(1);
    }
    50% {
      border-color: #0091d4;
      transform: scale(1.02);
    }
    100% {
      border-color: #dee2e6;
      transform: scale(1);
    }
  }

  &:hover {
    border-color: #0091d4;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
    font-size: 0.9rem;
  }
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`